import React from "react";
import { ContextualHelp, Heading, Content, Text } from "@adobe/react-spectrum";

function Instructions({...properties}) {
    return (
        <ContextualHelp variant="info" placement="top start" marginTop={properties.marginTop} marginBottom={properties.marginBottom} defaultOpen={true}>
            <Heading>Instructions</Heading>
            <Content>
                <Text>
                   {properties.text}
                </Text>
            </Content>
        </ContextualHelp>
    );
}

export default Instructions;
